import httpManager from "@/app/shared/utils/httpManager";

export async function fetchTextToSpeechExpenses({ filters, page = 1 } = {}) {
  // const limit = TABLE_PAGE_SIZE;
  // const offset = (page - 1) * TABLE_PAGE_SIZE;

  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const strategy_type = filters?.strategy_type == 0 ? "" : filters?.strategy_type || "";

  const url = `/billing/charges/tts-audios/`;
  const query = `?type_strategy=${strategy_type}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.get(`${url}${query}`);
  console.log("fetchTextToSpeechExpenses response:", response);
  return response.data;
}

export async function downloadTextToSpeechExpenses({ filters } = {}) {
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";
  const strategy_type = filters?.strategy_type == 0 ? "" : filters?.strategy_type || "";

  const url = `/billing/charges/tts-audios/download/`;
  const query = `?type_strategy=${strategy_type}&start_date=${startDate}&end_date=${endDate}`;

  const response = await httpManager.getBlob(`${url}${query}`);
  return response;

}
